import bulmaCollapsible from "@creativebulma/bulma-collapsible"

bulmaCollapsible.attach()
